module.exports = "<table class=\"table table-hover\">\r\n  <thead>\r\n      <tr>\r\n          <th>Form</th>\r\n      </tr>\r\n  </thead>\r\n  <tbody>\r\n      <tr ng-repeat=\"cf in $ctrl.customForms\">\r\n        <td><a href=\"#\" ng-click=\"$ctrl.action(cf.action)\" ng-show=\"$ctrl.show(cf.condition)\">{{cf.name}}</td>\r\n      </tr>\r\n  </tbody>\r\n</table>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/enquiry/enquiryEdit/customForms/customForms.html
// module id = 1411
// module chunks = 0